const baseUrl = process.env.REACT_APP_BASE_URL;

export default baseUrl 



export const cdnBaseUrl = process.env.REACT_APP_CDN_BASE_URL ?? '';
